import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M18 7a5 5 0 0 1-8.22 3.826l-1.946 1.947 1.258 1.258a.75.75 0 0 1-1.06 1.06l-1.259-1.257-.94.939 1.259 1.258a.75.75 0 0 1-1.06 1.06l-1.259-1.257-1.182 1.182a.75.75 0 1 1-1.06-1.061l6.258-6.258A5 5 0 1 1 18 7"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKey;
